
/**
 * Created by nijin on 9/3/17.
 */
import {Component, Input, OnInit} from '@angular/core';
import {FormGroup, Validators}        from '@angular/forms';
@Component({
  selector: 'df-attribute',
  templateUrl: './dynamic-form.html',
  styleUrls: ['./dynamic.scss'],
})
export class DynamicFormComponent implements  OnInit {
  @Input() attribute;
  @Input() form: FormGroup;
  @Input() formGroupName?: string;
  @Input() subName?: string;
  @Input() isAttribute: boolean;
  @Input() customClass?: string;

  private errorMessage = {

  };
  private validationMessages = {
    'number': {
      'required':     'Please enter a valid number',
      'maxlength': 'Cannot be more than 50 digits long for simulation',
    },
    'string': {
      'required': 'Required field',
      'maxlength': 'Cannot be more than 50 characters long for simulation',
    }


  };
  get isValid(){
    if (this.form.controls[this.formGroupName]|| this.form.controls[this.attribute.name]){
      return this.isAttribute ?
         this.form.controls[this.formGroupName]['controls'][this.attribute.name].valid :
        this.form.controls[this.attribute.name].valid;
    }
   return true;
  }

  ngOnInit() {
    let validators = this.attribute.required ? [Validators.required, Validators.maxLength(50)]
      : [Validators.maxLength(50)];
    if (this.isAttribute) {
      this.errorMessage[this.formGroupName] = {};
      this.errorMessage[this.formGroupName][this.attribute.name] = '';

        this.form.controls[this.formGroupName]['controls'][this.attribute.name]
          .setValidators(validators);

    } else {
      this.errorMessage[this.attribute.name] = '';
        this.form.controls[this.attribute.name]
          .setValidators(validators);
      }


    this.form.valueChanges.subscribe((data) => {
      this.onValueChanged(data);
    });

    this.onValueChanged();
  }

  onValueChanged(data?: any) {
    let control;
    if (this.isAttribute) {
      this.errorMessage[this.formGroupName][this.attribute.name] = '';
      control =  this.form.controls[this.formGroupName]['controls'][this.attribute.name];
    } else {
      this.errorMessage[this.attribute.name] = '';
      control =  this.form.controls[this.attribute.name];

    }
    if (control && (control.dirty && !control.valid)) {
      const messages = this.validationMessages[this.attribute.datatype];
      for (const key in control.errors) {
        this.isAttribute ? (this.errorMessage[this.formGroupName][this.attribute.name]  = messages[key])
          : (this.errorMessage[this.attribute.name] = messages[key]);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/things/things-details/event-simulation/dynamic-form/dynamic-form.ts